import * as actions from './actions';
import mutations from './mutations';

/** @type {INavigationState }*/
const state = {
    contentUID: 0,
    mainVisible: false,
    previewLinks: [],
    metanav: {
        links: [],
        languages: [],
    },
    isPreviewVisible: false,
    previewContent: null,
    previewAnchor: { x: 0, y: 0 },
    reducedNavVisibility: false,
};

export default {
    namespaced: true,
    mutations,
    actions,
    state,
};
